<template>
    <div className=" w-[45%] py-[15px] mx-auto">
        <div class=" text-[20px] font-normal px-[25px] text-black text-center">
            Exit
        </div>
        <div class="text-black px-[25px] mt-4 text-[14px] font-extralight text-center">
            Les champs du formulaire suivis d'un <span class="text-[#f44545]">*</span> sont obligatoire. veuillez lire le formulaire
            avant soummition
        </div>
        <form @submit.prevent="updateContrat" class="px-[25px] text-black mt-4">
            <div class="w-full flex flex-col items-start pt-4 text-black">
                <label for="debut" class="font-light" >Date du départ<span class="text-[#f44545]">*</span></label>
                <input v-model="formdata.date" type="date" name="debut" class="h-[40px] w-full rounded-md border outline-none bg-[#f9fafb] p-3 focus:outline-none">
            </div>
            <div class="w-full flex items-center justify-between mt-[8px]">
                <div class="w-full flex flex-col items-start ">
                    <label for="motif" class="font-light">Motif de départ<span class="text-[#f44545]">*</span></label>
                    <select v-model="formdata.exit_motive" name="shift" id="shift" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        <option value="">Selectionner le motif</option>
                    </select>
                </div>
            </div>

            <div class="w-full flex items-center justify-between mt-[8px]">
                <div class="w-full flex items-center justify-between ">
                    <label for="device" class="font-light">Equipement à déposer<span class="text-[#f44545]">*</span></label>
                    <input type="checkbox" v-model="formdata.devices" name="device" class="size-[16px] rounded-md border static opacity-100" id="device">
                </div>
            </div>
            <div className="w-full mt-4 gap-x-3 flex items-center justify-end">
                <button type="submit" :disabled="asSend" class="w-full py-3 bg-[#5357ec] text-white rounded-md">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Soumettre</span>
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import API from '@/service/API';
import Swal from 'sweetalert2';
import {
    Loader2
} from "lucide-vue-next";
export default {
    name: "ExitView",
    components:{Loader2},
    data(){
        return {
            contrat_id:"",
            asSend:false,
            formdata:{}
        }
    },
    mounted(){
        const id = localStorage.getItem("userId");
        this.getUsersInfo(id);
    },
    methods:{
        updateContrat(){
            this.asSend = true;
            API.put('user_profiles/' + this.contrat_id,this.formdata)
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message);
                Swal.fire('Succès',"Le formulaire a été soummit",'succes');
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.asSend = false;
            })
        },
        getUsersInfo(id){
            API.get('fetchUser/'+id)
            .then((response)=>{
                if(!response.data.status) throw Error(response.data.message);
                this.contrat_id = response.data.user.contrat?.id;
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{this.load = false});
        },
    }
}
</script>